import { ExaktValues } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/ExaktValues';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { DataDisplayPlain } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function Richtwert() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;
  return (
    <>
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwert.label',
        )}
        item={
          data.bezahlung.arbeitszeitkonto.stundenloehner.richtwert
            ? data.bezahlung.arbeitszeitkonto.stundenloehner
                .richtwertEinheit === 'euro'
              ? `${data.bezahlung.arbeitszeitkonto.stundenloehner.richtwertEuro} ${t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertEuro.suffix',
                )}`
              : data.bezahlung.arbeitszeitkonto.stundenloehner
                    .richtwertEinheit === 'stunden'
                ? `${data.bezahlung.arbeitszeitkonto.stundenloehner.richtwertStunden} ${t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertStunden.suffix',
                  )}`
                : t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwert.zusammenfassung.true',
                  )
            : t(
                'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwert.zusammenfassung.false',
              )
        }
      />
      {data.bezahlung.arbeitszeitkonto.stundenloehner.richtwert &&
        data.bezahlung.arbeitszeitkonto.stundenloehner.richtwertEinheit ===
          'exakt' && <ExaktValues />}
    </>
  );
}
